import { useState } from 'react';
import styles from './styles';

interface ToggleButtonProps {
  answer: {
    label: string;
    value: string;
  };
  onClick: (value: { [x: string]: boolean }) => void;
}

export default function ToggleButton({ answer, onClick }: ToggleButtonProps): JSX.Element {
  const [isToggled, setIsToggled] = useState(false);

  return (
    <>
      <button
        aria-label="toggle-button"
        className={`toggle-button ${isToggled && `toggled`}`}
        onClick={(): void => {
          setIsToggled(!isToggled);
          onClick({ [answer.value]: !isToggled });
        }}
      >
        <div>{answer.label}</div>
      </button>
      <style jsx>{styles}</style>
    </>
  );
}
